import styles from "@website/widget/footer/footer-row.module.scss";
import { FooterRowPropertiesType } from "@website/widget/footer/footer.types";

export const FooterRow: FooterRowPropertiesType = ({
  children,
  background
}) => (
  <div
    className={`${styles["footer-row"]} ${
      background ? styles[background] : ""
    }`}
  >
    <div className={styles["footer-row-container"]}>{children}</div>
  </div>
);
